import React, { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { baseUrl } from '../../../baseUrl';
import style from "./CloneExamModal.module.css"
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import api from '../../../api';

// Modal component
const CloneExamModal = ({ isOpen, closeModal }) => {
  const [originalExamID, setOriginalExamID] = useState('');
  const [targetExamID, setTargetExamID] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!originalExamID || !targetExamID) {
      swal('Error', 'Please provide both exam IDs!', 'error');
      return;
    }

    setLoading(true);

    try {
      // Send POST request to clone questions
      const response = await api.post(`${baseUrl}/question/clone`, {
        originalExamID,
        targetExamID,
      });

      swal('Success', response.data.message, 'success');
      closeModal(); // Close modal on success
    } catch (error) {
      swal('Error', error.response?.data?.message || 'An error occurred', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`${style.modal}`} style={modalStyles}>
      <div className={`modal-content ${style.modalContent}`}>
        <span className={`${style.close}`} onClick={closeModal}>&times;</span>
        <h4>Clone Questions from One Exam to Another</h4>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="originalExamID">Original Exam ID:</label>
            <input
              className='ml-2 mb-3 mt-2'
              type="text"
              id="originalExamID"
              value={originalExamID}
              onChange={(e) => setOriginalExamID(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="targetExamID">Target Exam ID:</label>
            <input
              className='ml-2'
              type="text"
              id="targetExamID"
              value={targetExamID}
              onChange={(e) => setTargetExamID(e.target.value)}
              required
            />
          </div>
          <div>
            <button className={`${style.cloneButton}`} type="submit" disabled={loading}>
              {loading ? <img width='25px' src='\assets\images\load-time.gif' alt='loading'/> : <ContentCopyTwoToneIcon/>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const modalStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  // maxWidth: '700px',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent dark background
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000, // Ensures the modal is above other content
  backdropFilter: 'blur(5px)', // Adds the blur effect behind the modal
};



export default CloneExamModal;
